import type { LoginUserAfterRedirectRequestData, LoginUserRequestData } from './types';
import { LoginRejectedPayload } from './types';

import { URL } from 'app/api/constants';
import type { ServiceConfig } from 'app/api/utils/create-http-api-service';
import { defaultRequestService } from 'app/api/utils/default-request-service';

export const logoutUser = (config: ServiceConfig) => {
  return defaultRequestService(URL.LOGOUT, config.instance.post);
};

export const loginUser = (
  config: ServiceConfig,
  requestData: LoginUserRequestData,
) => {
  type AdapterProps = { request: typeof requestData };
  return defaultRequestService<AdapterProps, void, LoginRejectedPayload>(
    URL.LOGIN, config.instance.post,
    { requestData },
  );
};

export const loginUserAfterRedirect = (
  config: ServiceConfig,
  requestData: LoginUserAfterRedirectRequestData,
) => {
  type AdapterProps = { request: typeof requestData };
  return defaultRequestService<AdapterProps>(URL.LOGIN_AFTER_REDIRECT, config.instance.post, {
    requestData,
  });
};
